import { render, staticRenderFns } from "./TeoricasRejeitadas.vue?vue&type=template&id=563c33f4"
import script from "./TeoricasRejeitadas.vue?vue&type=script&lang=js"
export * from "./TeoricasRejeitadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports